import { Signal } from "signals";
import { LiveEventData, LivePlayerDataEvent, LiveRoomData } from "../lib/game_snacks/ILiveMultiplayer";
import { Profile } from "../lib/game_snacks/IUser";


export default class MultiplayerEventManager
{
    // #region Attributes //

    // private:

    private _onProfileChange: Signal = null;
    private _onRoomLoaded: Signal = null;
    private _onPlayerPresenceUpdated: Signal = null;
    private _onEventsReceived: Signal = null;
    
    // #endregion //


    // #region Properties //

    public get onProfileChange(): Signal { return this._onProfileChange; }
    public get onRoomLoaded(): Signal { return this._onRoomLoaded; }
    public get onPlayerPresenceUpdated(): Signal { return this._onPlayerPresenceUpdated; }
    public get onEventsReceived(): Signal { return this._onEventsReceived; }

    // #endregion //


    // #region Methods //

    // public:

    public constructor()
    {
        this._onProfileChange = new Signal();
        this._onRoomLoaded = new Signal();
        this._onPlayerPresenceUpdated = new Signal();
        this._onEventsReceived = new Signal();

        window.GameSnacks.user.onProfileChange( 
            ( profile: Profile ) => {
                this._onProfileChange.dispatch( profile );
            } 
        );
        
        window.GameSnacks.liveMultiplayer.onRoomLoaded( 
            ( roomDataPromise: Promise<LiveRoomData> ) => {
                this._onRoomLoaded.dispatch( roomDataPromise );
            } 
        );

        window.GameSnacks.liveMultiplayer.onPlayerPresenceUpdated( 
            ( presenceEventPromise: Promise<LivePlayerDataEvent> ) => {
                this._onPlayerPresenceUpdated.dispatch( presenceEventPromise );
            } 
        );

        window.GameSnacks.liveMultiplayer.onEventsReceived(
            ( eventsPromise: Promise<LiveEventData[]> )=> {
                this._onEventsReceived.dispatch( eventsPromise );
            } 
        );
    }

    // #endregion //
}

export const enum game_event_type
{
    CARD_PLAYED = 0,
    LEAD_COLOR_SELECTED,
    CARD_DRAWN,
    AUTO_PLAY,
    PLAYER_KICKED,
    IM_ALIVE,
    PRIVATE_ROOM_ACCESS_GRANTED,
    PRIVATE_ROOM_FULL,
    GAME_ALREADY_STARTED,
    JOINED_PRIVATE_ROOM,
    PLAY_AGAIN_PRIVATE_GAME
}